var _desc, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuildIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Module-Puzzle-3--Streamline-Flex-Gradient.svg",
    height: 50,
    width: 50,
    strokeWidth: 1,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Module Puzzle 3 Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "module-puzzle-3--code-puzzle-module-programming-plugin-piece"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fill: "url(#paint0_linear_7718_1599)",
    fillRule: "evenodd",
    d: "M6.37499.24999c-.93192.028857-1.84293.117058-2.72263.215114C1.97795.651741.632566 1.99597.453099 3.67341c-.093482.87375-.17635 1.7774-.203591 2.70142H2.2267c.34517 0 .625.27982.625.625v.62245c0 .36107.2927.65377.65376.65377.36107 0 .65377-.2927.65377-.65377v-.62245c0-.34518.27982-.625.625-.625h1.59076V5.29952c-1.05025-.00137-1.90122-.85319-1.90122-1.90376s.85097-1.90239 1.90122-1.90377v-1.242ZM.249497 7.62483c.02723.92414.110108 1.82792.203602 2.70177.179467 1.6775 1.524851 3.0217 3.199261 3.2083.8797.0981 1.79071.1863 2.72263.2151v-2.2431c0-.3451.27982-.625.625-.625h.62246c.36106 0 .65376-.2927.65376-.6537 0-.36109-.2927-.65379-.65376-.65379h-.62246c-.34518 0-.625-.27983-.625-.625V7.62483h-.96576c-.00138 1.05025-.85319 1.90122-1.90377 1.90122-1.05057 0-1.90239-.85097-1.90376-1.90122H.249497ZM7.62499 13.75c.93193-.0288 1.84295-.117 2.72271-.2151 1.6744-.1866 3.0198-1.5308 3.1992-3.2083.0935-.87385.1764-1.77763.2036-2.70177h-2.1339c-.3451 0-.625-.27982-.625-.625v-.62246c0-.36106-.2927-.65376-.6537-.65376-.36109 0-.65379.2927-.65379.65376v.62246c0 .34518-.27982.625-.625.625H7.62499v.69958c1.05025.00137 1.90122.85319 1.90122 1.90379 0 1.0505-.85097 1.9024-1.90122 1.9037V13.75Zm6.12551-7.37517h-1.5089c-.0013-1.05025-.8532-1.90122-1.9037-1.90122-1.0506 0-1.90242.85097-1.90379 1.90122h-.80912V4.67452c0-.34517-.27982-.625-.625-.625h-.62246c-.36106 0-.65376-.2927-.65376-.65376 0-.36107.2927-.65377.65376-.65377h.62246c.34518 0 .625-.27982.625-.625V.249989c.93193.028856 1.84295.117058 2.72271.215115 1.6744.186637 3.0198 1.530866 3.1992 3.208306.0935.87375.1764 1.7774.2036 2.70142Z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7718_1599",
    x1: 2.456,
    x2: 13.36,
    y1: 2.846,
    y2: 8.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B557F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8841B9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildIcon);
export default __webpack_public_path__ + "static/media/build-icon.1d591a7238c38e583c4c35b8d8ced437.svg";
export { ForwardRef as ReactComponent };